<template>
  <div class="detailsBanner">
    <ol class="breadNav clearfix ">
      <li class="pull-left"><a href="#">招标公告</a></li>
      <li class="pull-left">通用</li>
      <li class="pull-left active">招标详情页</li>
    </ol>
  </div>
</template>
<script>
export default {
  props: [],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/detailsBanner/index.vue